import { render } from "./m-betview.vue?vue&type=template&id=1bc5d3a8&scoped=true&ts=true"
import script from "./m-betview.vue?vue&type=script&lang=ts"
export * from "./m-betview.vue?vue&type=script&lang=ts"

import "./m-betview.vue?vue&type=style&index=0&id=1bc5d3a8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc5d3a8"]])

export default __exports__